import classNames from "lib/classNames";
import CoverLink from "components/Cover/CoverLink";
import { BookGroupSizeType, BookSeriesContextType } from "../types";
import { BookSerializersBookByline } from "types/serializers";

export default function BookGroupSeriesItem({
  book,
  context,
  index,
  size,
}: {
  book: BookSerializersBookByline;
  context: BookSeriesContextType;
  index: number;
  size: BookGroupSizeType;
}) {
  const position = book.featuredSeries?.position;
  const active = context.activeBook?.id === book.id;

  return (
    <div className={classNames(
        index > 8 ? "block md:hidden lg:block" : "",
        index > 10 ? "lg:hidden" : "",
        index > 12 ? "hidden" : ""
    )}>
      <div className="relative group inline-block">
        {position > 0 && (
          <span
            className={classNames(
              "absolute bottom-0 right-0 z-10",
              "rounded-tl-lg rounded-br-[6px] px-2 py-1 text-sm font-bold",
              "bg-yellow-400 text-yellow-900",
              size === "lg"
                ? ""
                : "opacity-0 group-hover:opacity-100 transition-opacity duration-100"
            )}
          >
            #{position}
          </span>
        )}
        <CoverLink
          book={book}
          size={size === "lg" ? "md" : "sm"}
          variant={active ? "accent" : "none"}
          settings={{
            tooltip: true,
            showStatus: true,
            details: true,
          }}
        />
      </div>
    </div>
  );
}
